import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicProjectAvailableParamsRawI,
	type LWApiPublicProjectAvailableResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const PROJECT_AVAILABLE_QUERY_KEY = '/project/available';

const useProjectAvailable = (
	params: LWApiPublicProjectAvailableParamsRawI,
	options?: UseQueryOptions<LWApiPublicProjectAvailableResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [PROJECT_AVAILABLE_QUERY_KEY, params],
		queryFn: () => api.project.apiRaw.available(params),
		...options,
	});

export default useProjectAvailable;
